import React from 'react';
import { useSelector } from 'react-redux';
import BundleCards from 'src/common/components/orderDetails/bundleCards';
import { Layout } from './priceOverrideDetailsCardView.styled';
import { setItemsDataHandler } from 'src/utils/util';
import PriceOverrideContainer from 'src/pages/orders/components/orderDetails/priceOverride/priceOverrideDetails/priceOverrideContainer/PriceOverrideContainer';
import { useTranslation } from 'react-i18next';
const PriceOverrideDetailsCardView = ({
    tissue,
    nonTissue,
    totalTissuePrice,
    totalNonTissuePrice,
    handleSetItemClick,
    nonBilledList,
    total,
}) => {
    const { t } = useTranslation();
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const setItemHandler = (data, orderList) => {
        const setItemDetails = setItemsDataHandler(data, orderList);
        handleSetItemClick(setItemDetails);
    };
    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );

    const mobileSubItemsColumns = [
        {
            field: 'subItemsDescription',
            header: 'Items',
            width: '75%',
        },
        {
            field: 'quantity',
            header: t('consignmentBilling.priceOverride.priceOverrideTable.qty'),
            width: '20%',
        },
    ];
    const orderType = orderBasicDetails?.currentOrderType;
    const summaryCart = (priceOverrideList) => {
        return priceOverrideList?.length > 0 ? (
            <>
                {priceOverrideList?.map((data, index) => {
                    const isBundle = data?.isBundleHeader
                        ? data.isBundleHeader
                        : false;
                    return (
                        <BundleCards
                            key={index + data.cfn}
                            keyIndex={data.cfn}
                            isBundle={isBundle}
                            setItemHandler={setItemHandler}
                            setDetailsData={data}
                            cfn={data.cfn}
                            quantity={data.quantity}
                            serialNo={data.serialNo}
                            description={data.description}
                            unitPrice={data.unitPrice}
                            subUnitPrice={data.discountUnitPrice}
                            extPrice={data.extPrice}
                            subExtPrice={data.discountExtPrice}
                            uom={data.uom}
                            discount={
                                data?.discount &&
                                parseFloat(data.discount) !== 0
                                    ? parseFloat(data.discount).toFixed(2)
                                    : data.discount
                            }
                            subItemsData={
                                isBundle && data?.bundleItems?.length > 0
                                    ? data.bundleItems
                                    : []
                            }
                            subItemsColumns={
                                isBundle ? mobileSubItemsColumns : []
                            }
                            descriptionMobileFontSize={'13px'}
                            orderType={orderType}
                            isUsed={data.isUsed}
                            isAccountOwned={data.isAccountOwned}
                            isNotBilled={data.isNotBilled}
                            isDiscount={data.isDiscount}
                            poNumber={orderType === 'KE' ? data.poNumber : null}
                            isAttachment={
                                orderType === 'KE' ? data.poAttachment : null
                            }
                            textAlign={'left'}
                        />
                    );
                })}
            </>
        ) : null;
    };

    const priceOverrideContainer = (title, price, list, isNotBilled) => {
        return (
            <PriceOverrideContainer
                title={title}
                price={price}
                isNotBilled={isNotBilled}
                total={total}
            >
                {summaryCart(list)}
            </PriceOverrideContainer>
        );
    };

    return (
        <>
            <Layout>
                {nonTissue?.length > 0 ? (
                    <>
                        {priceOverrideContainer(
                            countryISOCode == 'US'
                                ? t('orders.orderTypes.nonTissue')
                                : t(
                                      'orders.shipTrackLabels.productItemDescriptionLabel'
                                  ),
                            totalNonTissuePrice,
                            nonTissue,
                            false
                        )}
                    </>
                ) : null}

                {tissue?.length > 0 ? (
                    <>
                        {priceOverrideContainer(
                            t('consignment.productType.type.tissue'),
                            totalTissuePrice,
                            tissue,
                            false
                        )}
                    </>
                ) : null}
                {nonBilledList?.length > 0 ? (
                    <>
                        {priceOverrideContainer(
                            t('reportUsage.summary.notBilled'),
                            0,
                            nonBilledList,
                            true
                        )}
                    </>
                ) : null}
            </Layout>
        </>
    );
};

export default PriceOverrideDetailsCardView;
